<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t27GpJ/tc-custom/9781423646501.jpg?1709193209436" alt="This image is the cover for the book Making Midcentury Modern"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Making Midcentury Modern
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed interior designer shares one hundred tips for bringing the principles of midcentury modern style to any home in this beautifully photographed volume.</b><br/><br/> With its minimalist elegance and nostalgic warmth, Midcentury modern style continues to capture the American consciousness. We see it everywhere from television shows to fashion runways. Yet, not all of us can live in a pedigreed midcentury home. Now, Springs interior designer Christopher Kennedy demonstrates how the principles of midcentury design can be applied to the most unassuming spaces.<br/><br/><i>Making Midcentury Modern</i> offers one hundred foolproof tips for introducing modernist design into a contemporary home. In line with forward-thinking designers of the midcentury, the simple yet inspiring ideas in this book are presented alongside stunning color photography.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Kennedy, Barclay Butera
      </h2>
      
      <p class="authorDescription body article">Christopher Kennedy has quickly and not-so-quietly emerged as one of the nation's freshest voices in home furnishings and interior design. Working from his studio and shop in Palm Springs, his name has become synonymous with Jet Set modern luxury and vibrant California glamour. Christopher's work and products have captured the attention of such leading publications as  Architectural Digest, Dwell Magazine, Elle Décor, Luxe Magazine, and The Los Angeles Times. In 2010, Christopher launched his own line of modern luxury furnishings, which is sold in to-the-trade showrooms across the country. The following year saw the expansion of his brand into candles, home décor, and outdoor furnishings.  He has several licensed product collaborations launching in the fall of 2016.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4af44361